<div nz-row nzType="flex" style="margin-bottom: 5px;">
  <div nz-col nzSpan="4">
    <div class="formname">{{formTitle}}</div>
  </div>

  <div nz-col nzSpan="20">
    <!-- <form nz-form [nzLayout]="'inline'"> -->

    <!-- <nz-form-item>
      <nz-form-label nzNoColon>For Me</nz-form-label>

      <nz-form-control>
        <nz-switch name="forMe" nzCheckedChildren="Y" nzUnCheckedChildren="N" [(ngModel)]="FOR_ME"
          (ngModelChange)="getRoadmapDetails()">
        </nz-switch>
      </nz-form-control>
    </nz-form-item>

    &nbsp;&nbsp; -->

    <!-- <nz-form-item>
      <nz-form-label nzNoColon>Module Status</nz-form-label>

      <nz-form-control>
        <nz-select style="width: 150px;" name="status" nzShowSearch nzAllowClear nzPlaceHolder="Select Module Status"
          [(ngModel)]="STATUS" (ngModelChange)="getRoadmapDetails()">
          <nz-option nzLabel="All" nzValue="All"></nz-option>
          <nz-option nzLabel="Pending" nzValue="P"></nz-option>
          <nz-option nzLabel="Started" nzValue="S"></nz-option>
          <nz-option nzLabel="Completed" nzValue="C"></nz-option>
          <nz-option nzLabel="On Hold" nzValue="OH"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    &nbsp;&nbsp; -->

    <nz-form-item>
      <nz-form-label nzNoColon><b>Project</b></nz-form-label>

      <nz-form-control>
        <div>
          <nz-select style="width: 100%;" name="projectName" nzShowSearch nzPlaceHolder="Select a Project"
            [(ngModel)]="PROJECT_ID" (ngModelChange)="getRoadmapDetails()">
            <span
              *ngIf="this.cookie.get('level') == '1' || this.cookie.get('level') == '2' || this.cookie.get('level') == '3'">
              <nz-option *ngFor="let project of projectList" [nzValue]="project.ID" [nzLabel]="project.NAME">
              </nz-option>
            </span>

            <span *ngIf="this.cookie.get('level') >= '4'">
              <nz-option *ngFor="let project of projectList" [nzValue]="project.PROJECT_ID" [nzLabel]="project.NAME">
              </nz-option>
            </span>
          </nz-select>
        </div>
      </nz-form-control>
    </nz-form-item>
    <!-- </form> -->
  </div>
</div>

<!-- <div style="text-align: center;" *ngIf="isRoadmapLoading">
 <nz-spin nzSimple></nz-spin>
</div> -->

<div *ngIf="nodes !=undefined && nodes != null" >
  <nz-spin [nzSpinning]="isRoadmapLoading">
  <ejs-treegrid [dataSource]='nodes' height='410' [treeColumnIndex]='1' [sortSettings]="sortSettings"
    [allowFiltering]="false" [allowSorting]="true" childMapping='children' [allowPaging]="false"
    [pageSettings]='pageSettings' [selectionSettings]='selectionOptions' [toolbar]='toolbarOption'>

    <e-columns>
      <e-column field='key' headerText='Action' textAlign='center' width=30></e-column>
      <e-column field='title' headerText='Name' textAlign='left' width=180></e-column>
      <e-column field='STATUS' headerText='Status' textAlign='center' width=40></e-column>
      <e-column field='START_DATE' headerText='Start Date' textAlign='center' width=40></e-column>
    </e-columns>

    <ng-template #rowTemplate let-nodes>
     
      <tr >
        <td align="center" class="border" style="cursor: pointer;">
          <!-- <nz-spin [nzSpinning]="isRoadmapLoading"> -->
          <span [nzTooltipTitle]="tooltipForView(nodes.title)" nzTooltipPlacement="top" nz-tooltip
            (click)="goToTask(nodes.key, nodes.TYPE)">
            <i style="font-size: 16px; margin-right: 5px;" nz-icon nzType="eye" nzTheme="outline"></i>
          </span>

          <span [nzTooltipTitle]="tooltipForWorklog(nodes.title)" nzTooltipPlacement="top" nz-tooltip
            (click)="addWorklog(nodes.key, nodes.TYPE)">
            <i style="font-size: 15px;" nz-icon nzType="history" nzTheme="outline"></i>
          </span>
        <!-- </nz-spin> -->
        </td>

        <td class="border" style='padding-left:18px;' style="cursor: pointer;">
          <div *ngIf="nodes.TYPE== 2">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 46 46">
              <g id="Epic_Icon" data-name="Epic Icon" transform="translate(-317 -1801)">
                <rect id="Rectangle_62" data-name="Rectangle 62" width="46" height="46" rx="6"
                  transform="translate(317 1801)" fill="#904ee2" />
                <path id="Union_1" data-name="Union 1" d="M9.849,16.819H0L10.151,0V10.005H20L9.849,26.824Z"
                  transform="translate(330 1811)" fill="#fff" />
              </g>
            </svg>

            {{nodes.title}}
          </div>

          <div *ngIf="nodes.TYPE== 3">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 46 46">
              <g id="Story_icon" data-name="Story icon" transform="translate(-317 -1801)">
                <rect id="Rectangle_62" data-name="Rectangle 62" width="46" height="46" rx="6"
                  transform="translate(317 1801)" fill="#63ba3c" />
                <path id="Path_23" data-name="Path 23"
                  d="M19.8,2.475V26.4L9.9,20.625,0,26.4V2.475A2.476,2.476,0,0,1,2.475,0h14.85A2.476,2.476,0,0,1,19.8,2.475Z"
                  transform="translate(330.2 1810.9)" fill="#fff" />
              </g>
            </svg>

            {{nodes.title}}
          </div>

          <div *ngIf="nodes.TYPE== 4">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 46 46">
              <g id="Task_Icon" data-name="Task Icon" transform="translate(-317 -1801)">
                <rect id="Rectangle_62" data-name="Rectangle 62" width="46" height="46" rx="6"
                  transform="translate(317 1801)" fill="#4bade8" />
                <path id="Path_26" data-name="Path 26"
                  d="M688.358-866.843s8.171,8.594,8.647,8.237,12.262-16.31,12.262-16.31"
                  transform="translate(-358.767 2690.416)" fill="none" stroke="#fff" stroke-linecap="round"
                  stroke-width="4" />
              </g>
            </svg>

            {{nodes.title}}
          </div>

          <div *ngIf="nodes.TYPE== 5">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 46 46">
              <g id="Task_Icon" data-name="Task Icon" transform="translate(-317 -1801)">
                <rect id="Rectangle_62" data-name="Rectangle 62" width="46" height="46" rx="6"
                  transform="translate(317 1801)" fill="#4bade8" />
                <g id="Rectangle_105" data-name="Rectangle 105" transform="translate(326 1810)" fill="#4bade8"
                  stroke="#fff" stroke-width="2">
                  <rect width="20" height="20" rx="4" stroke="none" />
                  <rect x="1" y="1" width="18" height="18" rx="3" fill="none" />
                </g>
                <rect id="Rectangle_106" data-name="Rectangle 106" width="20" height="20" rx="4"
                  transform="translate(336 1820)" fill="#fff" />
              </g>
            </svg>

            {{nodes.title}}
          </div>
        </td>

        <td align="center" class="border" style='padding: 5px 0px 5px 0px;'>
          <div>
            <nz-tag *ngIf="nodes.STATUS== 'P' || nodes.STATUS== 'TD'" [nzColor]="'red'">&nbsp; Pending &nbsp;</nz-tag>
            <nz-tag *ngIf="nodes.STATUS== 'S' || nodes.STATUS== 'IP'" [nzColor]="'green'">&nbsp; Started &nbsp;</nz-tag>
            <nz-tag *ngIf="nodes.STATUS== 'C'" [nzColor]="'yellow'">&nbsp; Completed &nbsp;</nz-tag>
            <nz-tag *ngIf="nodes.STATUS== 'OH'" [nzColor]="'blue'">&nbsp; On Hold &nbsp; </nz-tag>
          </div>
        </td>

        <td align="center" class="border">
          <div>
            {{nodes.START_DATE | date: 'dd-MMM-yyyy'}}
          </div>
        </td>
      </tr>
     
    </ng-template>
  </ejs-treegrid>
</nz-spin>
</div>
<div  *ngIf="commentDrawerVisible" >
  <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
    [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="800" [nzVisible]="commentDrawerVisible"
    [nzTitle]="commentDrawerTitle" (nzOnClose)="commentDrawerClose()" (nzKeyboard)="true" >
    <app-comment [data]="taskSubtaskDrawerData" [type]="typeForComment" [typeID]="typeIDForComment" [roadmaptrue]="roadmaptrue"></app-comment>
  </nz-drawer>
</div>
<div  *ngIf="viewModuleDrawerVisible" >
  <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
    [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="800" [nzVisible]="viewModuleDrawerVisible"
    [nzTitle]="viewModuleDrawerTitle" (nzOnClose)="viewModuleDetailsDrawerClose()" (nzKeyboard)="true">
    <app-module-feature-view [moduleData]="moduleDrawerData" [type]="type" [typeID]="typeID" [roadmaptrue]="roadmaptrue"></app-module-feature-view>
  </nz-drawer>
</div>
<div  *ngIf="viewFeatureDrawerVisible">
  <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
    [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="800" [nzVisible]="viewFeatureDrawerVisible"
    [nzTitle]="viewFeatureDrawerTitle" (nzOnClose)="viewFeatureDetailsDrawerClose()" (nzKeyboard)="true">
    <app-feature-view [featureData]="featureDrawerData" [type]="type" [typeID]="typeID" [roadmaptrue]="roadmaptrue"></app-feature-view>
  </nz-drawer>
</div>
<div  *ngIf="worklogDrawerVisible" >
  <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
    [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="500" [nzVisible]="worklogDrawerVisible"
    [nzTitle]="worklogDrawerTitle" (nzOnClose)="worklogDrawerClose()" (nzKeyboard)="true">
    <app-worklog-drawer [drawerClose]="callBackWorklogDrawerClose" [data]="worklogDrawerData"
      [typeData]="typeForWorklogDrawer" [typeIDData]="typeIDForWorklogDrawer" [estimatedHH]="estimatedHH"
      [estimatedMM]="estimatedMM" [estimatedSS]="estimatedSS" [estimatedMandays]="estimatedMandays"
      [estimatedTime_Mandays]="timeOrMandays"></app-worklog-drawer>
  </nz-drawer>
</div>